export async function getServiceRequests(token) {
    const url = 'api/service-request';

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer' + token,
            'Accept' : 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch service requests: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function saveServiceRequest(serviceRequestData, token) {

        const response = await fetch("/api/service-request", {
            method: "POST",
            body: serviceRequestData,
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to post service request: ${response.status}`);
        }

};

export async function deleteServiceRequest(serviceRequestId, token) {

    try {
        const response = await fetch(`/api/service-request/${serviceRequestId}`, {
            method: "DELETE",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json'
            }
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
        } else {
            const error = await response.text();
            console.log(error);
        }
    } catch (err) {
        console.log(err);
    }
};

export async function getServiceRequestByServiceRequestId(serviceRequestId, token) {
    const url = `/api/service-request/${serviceRequestId}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept' : 'application/json'
        }
    });
    if(!response.ok){
        throw new Error(`Failed to fetch service requests: ${response.status}`);
    }
    const data = await response.json();
    return data;
};


export async function getServiceRequestWithJiraProjectById(serviceRequestId, token) {
    const url = `/api/service-request/${serviceRequestId}/issues`;

        const response = await fetch(url, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept' : 'application/json'
            }
        });

    if(!response.ok){
        throw new Error(`Failed to fetch service requests: ${response.status}`);
    }
    const data = await response.json();
    return data;
};